export const DATE_FORMAT = 'DD/MM/YYYY';
export const PROSPECT_DATE_FORMAT = 'YYYY-MM-DD'
export const EIRCODE_FINDER_URL = 'https://finder.eircode.ie/#/';
export const MARKETING_PREFERENCES_NOTE = 'Subject to preferences you express below and the eir privacy policy, eir may keep you informed about existing and future offers,products and services of eir Group Companies; and third parties both during and after termination of our agreement.';
export const EIRCODE_LOGO_IMAGE_PATH = '/.galleries/eir/checkout/eircode-logo-small.png';
export const TERMS_AND_CONDITIONS_LINK =  'https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/Terms_and_Conditions_of_the_eir_Mobile_Service.pdf';

const REVIEW_ORDER_URL = '/review';
const CUSTOMER_DETAILS_URL = '/customerdetails';
const PAYMENT_URL = '/payment';
const CONFIRMATION_URL = '/confirmation';

const CONTACT_MOBILE_NUMBER = 'This mobile number will be used in case we need to contact you regarding your delivery.';
const DATE_OF_BIRTH_TOOLTIP = 'You need to be over 18 years old to buy prepay.';

const EXDIRECTORY = 'Ex-Directory - Not available for Directory Enquiries and not in the Phonebook';
const LISTED = 'Listed - Available for Directory Enquiries and in the Phonebook';
const UNLISTED = 'Unlisted - Available for Directory Enquiries but not in the Phonebook';

export const CHECKOUT_URLS = {
    REVIEW_ORDER_URL,
    CUSTOMER_DETAILS_URL,
    PAYMENT_URL,
    CONFIRMATION_URL,
};

export const TOOLTIP_TEXT = {
    CONTACT_MOBILE_NUMBER,
    DATE_OF_BIRTH_TOOLTIP
};

export const DIRECTORY_PREFERENCES = {
    EXDIRECTORY,
    LISTED,
    UNLISTED,
};

export const MARKETING_PREFERENCES = [
    {
        'name': 'As an existing eir customer',
        'permission': 'active',
        'enabled': false,
        'preferenceList': [
            {
                'enabled': false,
                'name': 'Email',
                'permission': 'EMAIL'
            },
            {
                'enabled': false,
                'name': 'SMS',
                'permission': 'SMS'
            },
            {
                'enabled': false,
                'name': 'Phone',
                'permission': 'Phone'
            },
            {
                'enabled': false,
                'name': 'Door to door',
                'permission': 'D2D'
            },
            {
                'enabled': false,
                'name': 'Direct mail',
                'permission': 'DirectMail'
            }
        ]
    },
    {
        'name': 'No longer an eir customer',
        'permission': 'inactive',
        'enabled': false,
        'preferenceList': [
            {
                'enabled': false,
                'name': 'Email',
                'permission': 'EMAIL'
            },
            {
                'enabled': false,
                'name': 'SMS',
                'permission': 'SMS'
            },
            {
                'enabled': false,
                'name': 'Phone',
                'permission': 'Phone'
            },
            {
                'enabled': false,
                'name': 'Door to door',
                'permission': 'D2D'
            },
            {
                'enabled': false,
                'name': 'Direct mail',
                'permission': 'DirectMail'
            }
        ]
    },
    {
        'name': '3rd party',
        'permission': '3P',
        'enabled': false,
        'tooltip': 'From time to time our partners might send you details about their products or services, are you ok with this?',
        'preferenceList': []
    }
];

export const SECURITY_QUESTIONS =
{
    'securityQuestions': [
        {
            'code': 'MEMORABLE_DATE',
            'question': ' Memorable Date'
        },
        {
            'code': 'MEMORABLE_WORD',
            'question': ' Memorable word'
        }
    ]
}
